import { useMemo } from "react";

// Quantity defaults to 1 so legacy products (without quantity) still count in total.
const getProductAmount = (product) => {
  const amount = Number(product?.quantity ?? 1);
  return Number.isFinite(amount) && amount > 0 ? amount : 1;
};

// Price is normalized to cents from masked strings like "12,99".
const getProductPriceInCents = (product) => {
  const rawPrice =
    product?.promotionPrice ?? product?.varejoPrice ?? product?.price ?? "";
  const cents = Number(String(rawPrice).replace(/\D/g, ""));
  return Number.isFinite(cents) ? cents : 0;
};

const formatCentsToCurrency = (valueInCents) => {
  const value = Math.max(0, Number(valueInCents) || 0);
  const reais = Math.floor(value / 100);
  const cents = String(value % 100).padStart(2, "0");
  return `R$ ${reais},${cents}`;
};

export default function useCestaBasicaKitValorTotal(products = []) {
  // Keep both numeric and formatted totals available for reuse.
  const kitValorTotalInCents = useMemo(() => {
    return products.reduce((acc, product) => {
      return acc + getProductPriceInCents(product) * getProductAmount(product);
    }, 0);
  }, [products]);

  const kitValorTotal = useMemo(() => {
    return formatCentsToCurrency(kitValorTotalInCents);
  }, [kitValorTotalInCents]);

  return {
    kitValorTotal,
    kitValorTotalInCents,
  };
}
